import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc57470a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel",
  style: {"gap":"8px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Description", -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Algorithm", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "save-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_IciButton = _resolveComponent("IciButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Textarea, {
        modelValue: _ctx.description,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
        rows: "3",
        cols: "150"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Textarea, {
        modelValue: _ctx.algorithm,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.algorithm) = $event)),
        rows: "15",
        cols: "150"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_IciButton, {
        id: "submit",
        content: "Save",
        onButtonClick: this.save,
        btnStyle: "width: 140px;",
        dark: true
      }, null, 8, ["onButtonClick"])
    ])
  ]))
}